import { render, staticRenderFns } from "./ReviewFunnel.vue?vue&type=template&id=8bd1a65a&scoped=true"
import script from "./ReviewFunnel.vue?vue&type=script&lang=js"
export * from "./ReviewFunnel.vue?vue&type=script&lang=js"
import style0 from "./ReviewFunnel.vue?vue&type=style&index=0&id=8bd1a65a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd1a65a",
  null
  
)

export default component.exports